import './ArrLoadingSpinner.scss';
import React from 'react';
import {CircularProgress, Box, Dialog} from '@mui/material';
import {A11yStatusProps} from '../../../shared/types';
import {mapA11yStatusProps} from '../../../utils/utils';
import {t} from 'i18next';

const DEFAULT_THICKNESS = 5;

interface ArrLoadingIndicatorProps extends A11yStatusProps {
  size?: number;
  show?: boolean;
  loaderThickness?: number;
  className?: string;
  overlay?: boolean;
  isOpen?: boolean;
  color?: 'primary' | 'secondary';
  containerClass?: string;
}

const ArrLoadingSpinner: React.FC<ArrLoadingIndicatorProps> = React.memo(
  ({
    size = 64,
    show = true,
    loaderThickness = DEFAULT_THICKNESS,
    className = '',
    overlay = false,
    isOpen = false,
    color = 'primary',
    containerClass = '',
    role,
    ariaLive,
    ariaLabel,
  }) => {
    if (!show) return null;

    const a11yProps = mapA11yStatusProps({
      ariaLive: ariaLive ?? 'polite',
      ariaAtomic: true,
      ariaLabel: ariaLabel ?? t('common.loading'),
    });

    const spinner = (
      <Box
        className={`arr-loading-indicator-component color-${color}`}
        {...a11yProps}
      >
        <CircularProgress
          size={size}
          color="inherit"
          thickness={loaderThickness}
          className={className}
          aria-hidden="true"
        />
      </Box>
    );

    if (overlay) {
      return (
        <Dialog
          fullScreen
          open={isOpen}
          aria-label={ariaLabel ?? t('common.loading')}
          slotProps={{
            paper: {
              className: 'overlay',
            },
          }}
          className="overlay-container"
          data-testid="loading-overlay"
        >
          {spinner}
        </Dialog>
      );
    }

    return (
      <div
        data-testid="loading-container"
        className={`arr-loading-container ${containerClass}`}
      >
        {spinner}
      </div>
    );
  }
);

export default ArrLoadingSpinner;
